import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/login/login.component').then(m => m.LoginComponent),
      },
    ],
  },
  {
    path: 'map',
    loadComponent: () =>
      import('./features/map/map.component').then(m => m.MapComponent),
    canActivate: [authGuard],
  },
  {
    path: 'projects',
    loadComponent: () =>
      import('./features/projects/projects.component').then(m => m.ProjectsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'entry',
    canActivate: [authGuard],
    children: [
      {
        path: 'add-pin',
        loadComponent: () =>
          import('./features/entries/add-pin/add-pin.component').then(m => m.AddPinComponent),
      },
      {
        path: 'draw',
        loadComponent: () =>
          import('./features/entries/draw-field/draw-field.component').then(m => m.DrawFieldComponent),
      },
      {
        path: ':id/adjust-location',
        loadComponent: () =>
          import('./features/entries/adjust-location/adjust-location.component').then(m => m.AdjustLocationComponent),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./features/entries/entry-detail/entry-detail.component').then(m => m.EntryDetailComponent),
      },
      {
        path: ':id/notes',
        loadComponent: () =>
          import('./features/entries/notes/notes.component').then(m => m.NotesComponent),
      },
      {
        path: ':id/photos',
        loadComponent: () =>
          import('./features/entries/photos/photos.component').then(m => m.PhotosComponent),
      },
    ],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'map',
  },
];
